<template>
  <div class="main">
    <Header 
      :show="true"
      title="生产开关"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="通过人工进行干预，请谨慎修改"
      />
      <van-form>
        <van-field 
          v-for="item in table.data"
          :key="item.id"
          :label="item.name"
          :name="item.name" 
          required
        >
          <template #input>
            <van-switch 
              size="20" 
              :value="item.checked === '开启' ? true : false"
              @input="checkPermission([102]) === true ? handleInputSwitch($event, item) : null"
            />
          </template>
        </van-field>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>

  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getList, updateOne } from '@/api/switch.js'

  export default {
    name: "ServiceProjectSwitch",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        table: {
          listLoading: false,
          height: document.documentElement.clientHeight-340,
          key: 0,
          total: 0,
          data: []
        },
        listQuery: {
          page: 1,
          limit: 10,
          serial: '',
          checked: 0,
          remark: ''
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/staff/create', 
          query: {} ,
        })
      },
      handleClickQuery() {
        const data = {}
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              if (items[i].type === '生产开关') {
                this.table.data.push({
                  id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                  serial: items[i].id,
                  name: items[i].name,
                  checked: items[i].value,
                  remark: items[i].remark
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleInputSwitch(value, row) {
        Dialog.confirm({
          title: '提醒',
          message: '是否切换生产开关？',
        }).then(() => {
          if (value === true) {
            row.checked = '开启'
          } else {
            row.checked = '关闭'
          }
          const data = {
            id: row.serial,
            value: row.checked
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新生产开关', data.message)) {
              this.handleClickQuery()
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .van-cell__title {
    max-width: 100%;
  }
  ::v-deep .van-field__label {
    width: 80%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
